import React, { useMemo } from 'react'
import { Col, Container, Row, Stack } from 'react-bootstrap'
import { useAppSelector } from '../../../../store/hooks'
import { selectAccountId } from '../../../../store/auth/authSlice'
import { useDeleteUserIntegrationMutation, useGetMeQuery } from '../../../../store/user/user'
import { IntegrationServiceId } from '../../../../common/integrations'
import { Button } from '../../../../components/Button/Button'
import { IntegrationIcon } from '../../../../components/IntegrationIcon'

export type CLICIntegrationRowProps = {}

export const CLICIntegrationRow: React.FC<CLICIntegrationRowProps> = () => {
  const accountId = useAppSelector(selectAccountId)
  const { data: userData } = useGetMeQuery({ accountId: accountId }, { refetchOnMountOrArgChange: true })
  const [deleteUserIntegration, { isLoading: isDeletingIntegration }] = useDeleteUserIntegrationMutation()

  const hasCLICIntegration = useMemo(() => {
    return !!(userData && userData.integrations && userData.integrations.some((i) => i.serviceId === IntegrationServiceId.CLIC))
  }, [userData])

  const uninsttallCLIC = () => {
    const user = userData
    if (!user || !user.integrations) {
      return
    }
    const integration = user.integrations.find((i) => i.serviceId === IntegrationServiceId.CLIC)
    if (integration) {
      deleteUserIntegration({
        accountId,
        payload: {
          userId: user.id,
          integrationId: integration.id,
        },
      })
    }
  }

  return (
    <Container className='p-3 p-md-0 py-md-3 integration-container'>
      <Row className='d-flex justify-content-between'>
        <Col>
          <Stack direction='horizontal' className='gap-4 pb-4 pb-md-0'>
            <div className='rounded py-1 px-1 zocks-bg-color-gray-100'>
              <IntegrationIcon serviceId={IntegrationServiceId.CLIC} width={48} height={48} />
            </div>
            <div>
              <h6>CLIC</h6>
              <div>Connect your Zocks account to CLIC.</div>
            </div>
          </Stack>
        </Col>
        <Col md='auto'>
          <div className='connect-button-container'>
            {hasCLICIntegration ? (
              <div className='connect-button-container'>
                <Button variant='primary' onClick={uninsttallCLIC} loading={isDeletingIntegration}>
                  Disconnect
                </Button>
              </div>
            ) : null}
          </div>
        </Col>
      </Row>
    </Container>
  )
}
